 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="overduePicksForm" :model="overduePicksForm" 
        size="mini" label-width="120px">
            <el-form-item label="提单号" prop="blNo"> 
                <el-input v-model="overduePicksForm.blNo" placeholder="请输入提单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getOverduePicksList">搜索</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <vxe-table id="overduePicksTable"  size="mini" ref="overduePicksTable" :data="overduePicksList" border stripe
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="auto">
                <!-- <vxe-column type="checkbox" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="declareDate" title="报关日期" width="110" sortable ></vxe-column>
                <vxe-column field="endDate" title="截止日期"  sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="ckName" title="仓库名称"  ></vxe-column>
                <vxe-column field="blKgs" title="申报数量"  ></vxe-column>
                <vxe-column field="notifyPerson" title="客户经理" width="130"  ></vxe-column>
                <vxe-column field="createMan" title="创建人" width="130"  ></vxe-column>
                <vxe-column field="remark" title="备注"  ></vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getOverduePicksListPager" size="mini">
        </vxe-pager>
         
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
export default {
    name: 'overduePickList',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            overduePicksForm:{
                blNo:"",
            },
            overduePicksList:[],
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 50, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100,200],
        }
    },
    created() {
        this.getOverduePicksList()
    },
    mounted() {

    },
    methods: {
        // 获取数据
        getOverduePicksList() { 
            this.pagination.currentPage = 1
            this.$api.wmsGetOverduePicks( this.pagination.pageSize,this.pagination.currentPage ,this.overduePicksForm ).then(async res =>{
                this.overduePicksList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        getOverduePicksListPager(){
            this.$api.wmsGetOverduePicks( this.pagination.pageSize,this.pagination.currentPage ,this.overduePicksForm ).then(async res =>{
                this.overduePicksList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
    }
}
</script>